import { axios } from '@lib/axios';
import { ScheduleRuleRole } from 'chaika-enums';
import {
    ScheduleRuleCreationParams,
    ScheduleRuleListResponse,
    ScheduleRuleResponse,
    ScheduleRuleUpdateParams,
    ScheduleRuleViewModel,
} from 'chaika-types';
import { Optional } from 'chaika-common-types';

const BASE_URL = '/api/schedule-rule';

export interface ScheduleRuleFilters {
    officeId?: string[];
    userId?: string[];
    clinicId?: string[];
    role?: ScheduleRuleRole;
}

export class ScheduleRuleApi {
    public static async list(filters: ScheduleRuleFilters = {}): Promise<ScheduleRuleViewModel[]> {
        const res = await axios.get<ScheduleRuleListResponse>(`${BASE_URL}`, {
            params: {
                officeId: filters.officeId?.join(','),
                userId: filters.userId?.join(','),
                clinicId: filters.clinicId?.join(','),
                role: filters.role,
            },
        });

        return res.data.scheduleRules;
    }

    public static async get(id: string): Promise<Optional<ScheduleRuleViewModel>> {
        const res = await axios.get<ScheduleRuleResponse>(`${BASE_URL}/${id}`);

        return res.data.scheduleRule;
    }

    public static async create(scheduleRule: ScheduleRuleCreationParams): Promise<void> {
        await axios.post(`${BASE_URL}`, { scheduleRule });
    }

    public static async createMany(scheduleRules: ScheduleRuleCreationParams[]): Promise<void> {
        await axios.post(`${BASE_URL}/batch`, { scheduleRules });
    }

    public static async update(
        id: string,
        scheduleRule: ScheduleRuleUpdateParams,
        effectiveFrom?: string,
    ): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { scheduleRule, effectiveFrom });
    }

    public static async excludeDay(id: string, day: string): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/exclude-day`, { day });
    }

    public static async delete(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }
}
